import React from 'react';
import BookingForm from './BookingForm';
import TrustBadges from './TrustBadges';
import TrustBar from './TrustBar';
import { Check, Clock, CreditCard, Shield } from 'lucide-react';

const HeroSection = () => {
  // Feature list - explanatory emphasis with neutral icons
  const features = [
    { text: 'Free cancellation up to 24h' },
    { text: 'Complimentary meet & greet' },
    { text: '60 min free waiting time' },
    { text: 'No hidden fees' },
  ];

  return (
    <section className="relative min-h-screen bg-background overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1619672161512-5253ed90b797?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtZXJjZWRlcyUyMGFpcnBvcnR8ZW58MHx8fGJsYWNrfDE3NjgwMjc5Njd8MA&ixlib=rb-4.1.0&q=85"
          alt="Premium airport transfer"
          className="w-full h-full object-cover object-center"
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-background/80"></div>
        {/* Gradient overlay from bottom */}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent"></div>
      </div>

      {/* Grain texture overlay */}
      <div className="absolute inset-0 grain-overlay pointer-events-none"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 md:pt-36 pb-16">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* Left Column - Hero Content */}
          <div className="space-y-8">
            <div className="space-y-6 animate-fade-in-up">
              <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
                Premium Airport Transfers in{' '}
                <span className="text-primary">Turkey</span>
              </h1>
              <p className="text-lg sm:text-xl text-foreground/70 max-w-xl leading-relaxed">
                Licensed drivers, fixed prices, and 24/7 availability.
                Pay securely with <span className="text-primary font-semibold">PayPal</span>, Stripe, or Card.
              </p>
            </div>

            {/* Trust Badges - ONE primary badge row (desktop only) */}
            <div className="hidden lg:block animate-fade-in-up animation-delay-200" data-testid="trust-primary">
              <TrustBadges />
            </div>

            {/* Key Features - Explanatory emphasis with neutral icons */}
            <div className="hidden lg:block animate-fade-in-up animation-delay-300" data-testid="trust-features">
              <div className="grid grid-cols-2 gap-3">
                {features.map((feature, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-3 text-foreground/80"
                  >
                    <span className="flex items-center justify-center w-5 h-5 rounded-full bg-primary/10 text-primary">
                      <Check className="h-3 w-3" />
                    </span>
                    <span className="text-sm">{feature.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Column - Booking Form */}
          <div className="animate-slide-in-right animation-delay-100">
            {/* Mobile Trust Bar - Above form */}
            <div className="lg:hidden mb-4">
              <TrustBar variant="full" />
            </div>
            
            <BookingForm />
          </div>
        </div>
      </div>

      {/* Road Lane Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-background">
        <div className="max-w-7xl mx-auto px-4">
          <div className="road-lane-pattern opacity-20"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
